module.exports = __webpack_public_path__ + "img/partner_06.c461ff11.png";